"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _I18n = require("./I18n");

var _loglevel = _interopRequireDefault(require("loglevel"));

var _utils = require("./utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/**
 * Component for transformation
 * @param children
 * @param value
 */
var Transform = function Transform(_ref) {
  var children = _ref.children,
      data = _ref.data;

  var _useI18n = (0, _I18n.useI18n)(),
      transform = _useI18n.transform,
      ready = _useI18n.ready;

  if (!ready) {
    _loglevel["default"].debug("Not ready yet");

    return null;
  }

  if (!data) {
    _loglevel["default"].warn("No value provided");

    return children;
  }

  var value = transform(data);

  if (!value) {
    if (children) {
      _loglevel["default"].debug("Falling back to children");

      if (typeof children !== "function") {
        return children; // Fallback to children
      }

      return children(null);
    }

    return null;
  }

  if (children) {
    if (typeof children === "function") {
      return children(value);
    }
  }

  var result = value;

  if (Array.isArray(value)) {
    result = value.map(_utils.getComponent);
  }

  return result;
};

Transform.propTypes = {
  value: _propTypes["default"].any.isRequired
};
var _default = Transform;
exports["default"] = _default;